// extracted by mini-css-extract-plugin
export default {"wrapper":"DynamicsChart_wrapper__tuXXh","empty":"DynamicsChart_empty__fY5Q1","empty__text":"DynamicsChart_empty__text__E3472"};